<div class="circle">
  <app-spinner></app-spinner>
</div>
<div *ngIf="!!title || !!body" fxLayout="column" fxLayoutAlign="center center" class="labels">
  <h2>{{title}}</h2>
  <p>{{body}}</p>
</div>
